// extracted by mini-css-extract-plugin
export var crossplat = "styles-module--crossplat--1Gmg-";
export var crossplat_txt = "styles-module--crossplat_txt--2C9eq";
export var crossplat_txt_title = "styles-module--crossplat_txt_title--3W1G_";
export var crossplat_img = "styles-module--crossplat_img--1yIRA";